import { Users, Trophy, Target, Lightbulb, Code, TrendingUp, Award, Rocket } from 'lucide-react';
import marselPhoto from "../assets/team/marsel.png";
import aliPhoto from "../assets/team/ali.jpeg";
import kadyrPhoto from "../assets/team/kadyr.jpeg";
import aidosPhoto from "../assets/team/aidos.jpg";
import akhanPhoto from "../assets/team/akhan.jpeg";
import abylaiPhoto from "../assets/team/abylai.jpeg";
import kamilaPhoto from "../assets/team/kamila.jpeg";
import samPhoto from "../assets/team/sam.jpeg";
import calaiPhoto from "../assets/team/calai.png";
import aviatoPhoto from "../assets/team/aviato.png";
import linePhoto from "../assets/team/line.png";

export const mockData = {
  stats: [
    { icon: Users, value: '25+', labelKey: 'activeStartups' },
    { icon: Trophy, value: '₸10M+', labelKey: 'fundingRaised' },
    { icon: Award, value: '10+', labelKey: 'mentors' },
    { icon: Rocket, value: '100%', labelKey: 'successRate' }
  ],
  
  features: [
    { icon: Lightbulb, titleKey: 'innovationHub.title', descriptionKey: 'innovationHub.description' },
    { icon: Users, titleKey: 'communityNetwork.title', descriptionKey: 'communityNetwork.description' },
    { icon: TrendingUp, titleKey: 'growthAcceleration.title', descriptionKey: 'growthAcceleration.description' },
    { icon: Code, titleKey: 'techExcellence.title', descriptionKey: 'techExcellence.description' },
    { icon: Target, titleKey: 'marketFocus.title', descriptionKey: 'marketFocus.description' },
    { icon: Award, titleKey: 'recognition.title', descriptionKey: 'recognition.description' }
  ],
  
  successStories: [
    { companyKey: 'techFlow.company', industryKey: 'techFlow.industry', founderKey: 'techFlow.founder', testimonialKey: 'techFlow.testimonial', fundingKey: 'techFlow.funding', image: calaiPhoto },
    { companyKey: 'dataVault.company', industryKey: 'dataVault.industry', founderKey: 'dataVault.founder', testimonialKey: 'dataVault.testimonial', fundingKey: 'dataVault.funding', image: aviatoPhoto },
    { companyKey: 'eduTech.company', industryKey: 'eduTech.industry', founderKey: 'eduTech.founder', testimonialKey: 'eduTech.testimonial', fundingKey: 'eduTech.funding', image: linePhoto }
  ],

    mission: {
    values: [
      {
        titleKey: "about.mission.values.education.title",
        descKey: "about.mission.values.education.desc",
      },
      {
        titleKey: "about.mission.values.community.title",
        descKey: "about.mission.values.community.desc",
      },
      {
        titleKey: "about.mission.values.innovation.title",
        descKey: "about.mission.values.innovation.desc",
      },
    ],
  },

  impact: [
    { value: "60к+", labelKey: "about.impact.startups" },
    { value: "₸10M+", labelKey: "about.impact.capital" },
    { value: "25+", labelKey: "about.impact.participants" },
    { value: "10+", labelKey: "about.impact.mentors" },
  ],
  
  team: [
    {
      name: "Marsel Bekturganov",
      roleKey: "about.team.members.marsel.role",
      bioKey: "about.team.members.marsel.bio",
      expertiseKeys: [
        "about.team.expertise.STEM",
        "about.team.expertise.fundraising",
        "about.team.expertise.boxing&basketball"
      ],
      image: marselPhoto
    },
    {
      name: "Kadyr Saparbay",
      roleKey: "about.team.members.kadyr.role",
      bioKey: "about.team.members.kadyr.bio",
      expertiseKeys: [
        "about.team.expertise.ai",
        "about.team.expertise.architecture",
        "about.team.expertise.development"
      ],
      image: kadyrPhoto
    },
    {
      name: "Alimurtaza Mazhitov",
      roleKey: "about.team.members.ali.role",
      bioKey: "about.team.members.ali.bio",
      expertiseKeys: [
        "about.team.expertise.investors",
        "about.team.expertise.pitch",
        "about.team.expertise.due"
      ],
      image: aliPhoto
    },
    {
      name: "Aidos Yeldosuly",
      roleKey: "about.team.members.aidos.role",
      bioKey: "about.team.members.aidos.bio",
      expertiseKeys: [
        "about.team.expertise.education",
        "about.team.expertise.youth",
        "about.team.expertise.community"
      ],
      image: aidosPhoto
    },
    {
      name: "Akhan Tuleuov",
      roleKey: "about.team.members.akhan.role",
      bioKey: "about.team.members.akhan.bio",
      expertiseKeys: [
        "about.team.expertise.video",
        "about.team.expertise.robotics",
        "about.team.expertise.gym"
      ],
      image: akhanPhoto
    },
    {
      name: "Abylai Sabyrzhan",
      roleKey: "about.team.members.abylai.role",
      bioKey: "about.team.members.abylai.bio",
      expertiseKeys: [
        "about.team.expertise.abba",
        "about.team.expertise.abba2",
        "about.team.expertise.abba3"
      ],
      image: abylaiPhoto
    },
        {
      name: "Kamila Atayeva",
      roleKey: "about.team.members.kamila.role",
      bioKey: "about.team.members.kamila.bio",
      expertiseKeys: [
        "about.team.expertise.kamma",
        "about.team.expertise.kamma2",
        "about.team.expertise.kamma3"
      ],
      image: kamilaPhoto
    },
        {
      name: "Samal Abdreimova",
      roleKey: "about.team.members.samal.role",
      bioKey: "about.team.members.samal.bio",
      expertiseKeys: [
        "about.team.expertise.sam",
        "about.team.expertise.sam2",
        "about.team.expertise.sam3"
      ],
      image: samPhoto
    }
  ],

  programs: [
    {
      key: "accelerator",
      titleKey: "about.programs.accelerator.title",
      descriptionKey: "about.programs.accelerator.description",
      benefitsKeys: [
        "about.programs.accelerator.benefits.investment",
        "about.programs.accelerator.benefits.mentorship",
        "about.programs.accelerator.benefits.posts"
      ],
      eligibilityKey: "about.programs.accelerator.eligibility",
      critKey: "about.programs.accelerator.crit"
    },
    {
      key: "prize",
      titleKey: "about.programs.prize.title",
      descriptionKey: "about.programs.prize.description",
      benefitsKeys: [
        "about.programs.prize.benefits.total",
        "about.programs.prize.benefits.top1",
        "about.programs.prize.benefits.top2",
        "about.programs.prize.benefits.top3",
        "about.programs.prize.benefits.guaranteed"
      ],
      eligibilityKey: "about.programs.prize.eligibility",

    },
    {
      key: "bootcamp",
      titleKey: "about.programs.bootcamp.title",
      descriptionKey: "about.programs.bootcamp.description",
      benefitsKeys: [
        "about.programs.bootcamp.benefits.dealflow",
        "about.programs.bootcamp.benefits.portfolio",
        "about.programs.bootcamp.benefits.network",
        "about.programs.bootcamp.benefits.frameworks"
      ],
      eligibilityKey: "about.programs.bootcamp.eligibility"
    }
  ],

  applicationProcess: [
    {
      step: 1,
      titleKey: "about.application.step1.title",
      descriptionKey: "about.application.step1.description"
    },
    {
      step: 2,
      titleKey: "about.application.step2.title",
      descriptionKey: "about.application.step2.description"
    },
    {
      step: 3,
      titleKey: "about.application.step3.title",
      descriptionKey: "about.application.step3.description"
    },
    {
      step: 4,
      titleKey: "about.application.step4.title",
      descriptionKey: "about.application.step4.description"
    }
  ]
};